// Generated from build58 src/utils/remoteImageUrl.ts; do not edit.
export function secureRemoteImageUrl(value) {
  const normalized = value?.trim();
  if (!normalized) return undefined;
  return normalized.startsWith('http://')
    ? `https://${normalized.slice('http://'.length)}`
    : normalized;
}
